import * as React from "react";
import * as Scrivito from "scrivito";
import { MultiselectComponent } from "components/MultiselectField";

let id = 0;

type Attributes = { attribute: string; title: string; values: string[] };

export const createMultiselectComponent = (attributes: Attributes[] = []) => {
  const name = `ScrivitoMultiselectField${(id += 1)}`;
  Scrivito.registerComponent(name, (props) => (
    <MultiselectComponent attributes={attributes} {...props} />
  ));
  return name;
};
